import React from 'react';
import BankTransferDetails from './BankTransferDetails';
import { FaMoneyBillWave, FaUniversity } from 'react-icons/fa';

const PaymentMethodSelector = ({
  loadingPaymentMethods,
  paymentMethods,
  selectedPayment,
  handlePaymentChange
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h3 className="font-bold text-lg mb-5 pb-3 border-b border-gray-200">Метод на плащане</h3>
      {loadingPaymentMethods ? (
        <div className="py-8 flex flex-col items-center justify-center">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
        </div>
      ) : paymentMethods.length === 0 ? (
        <div className="py-4 text-red-600 text-center border border-dashed border-gray-200 rounded-md">
          Няма налични методи за плащане.
        </div>
      ) : (
        <div className="flex flex-col space-y-3">
          {paymentMethods.map((method) => (
            <div key={method.id} className="p-4 border border-gray-200 rounded-md bg-gray-50">
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="radio"
                  name="payment"
                  value={method.id}
                  checked={selectedPayment === method.id}
                  onChange={handlePaymentChange}
                />
                {method.id === 'bacs' && (
                  <FaUniversity className="text-blue-700" size={18} />
                )}
                {method.id === 'cod' && (
                  <FaMoneyBillWave className="text-green-600" size={18} />
                )}
                <div className="font-medium">{method.title}</div>
              </label>
              {method.id === 'bacs' && selectedPayment === 'bacs' && (
                <BankTransferDetails />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PaymentMethodSelector; 